(function(){
  // === P0 hotfix 2026-05-20: ensure [data-buy] clicks always bind, even if later IIFE code throws.
  // Event delegation on document.body — survives DOM mutations + late-script-throw + section reorder.
  // The legacy direct-binding at line ~722 is kept as a no-op duplicate; this delegation is the real handler.
  document.body.addEventListener('click', function(e){
    var btn = e.target.closest('[data-buy]');
    if (!btn) return;
    // Defense in depth: never resolve a line item from a disabled / unavailable Buy button.
    // The mix-pack picker marks an unresolved/unminted combo .is-unavailable; gnEnableBuyCtas
    // re-enables [data-buy] on gokwikLoaded but leaves the class, so guard on it here too —
    // otherwise a pending mixed combo would fall through to case-4 and over-bill.
    if (btn.disabled || btn.classList.contains('is-unavailable')) return;
    e.preventDefault();
    // 2026-09-15 checkout-speed: one checkout at a time for the whole page. Hero, sticky and
    // lower CTAs are often on screen together, and a second chain started while the first is
    // in flight can merge into a double-quantity cart. Released only when GoKwik is visible.
    if (window.__pcsBusy) return;
    if (typeof window.principalBuyClick === 'function') {
      window.principalBuyClick(btn);
      return;
    }
    // Fallback if principalBuyClick didn't get defined (IIFE threw before line 721 ran):
    // best-effort clear → add → /checkout via cn1BuyMeta or principalBuyMeta variant id.
    var meta = document.getElementById('cn1BuyMeta') || document.getElementById('principalBuyMeta');
    if (!meta || !meta.dataset.variantId) return;
    var qty = Math.max(1, parseInt(btn.dataset.buyQty || '1', 10));
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .then(function(){ return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: parseInt(meta.dataset.variantId, 10), quantity: qty }] })
      }); })
      .then(function(){
        if (typeof window.gokwikBuyNowClickFn === 'function') window.gokwikBuyNowClickFn(btn);
        else if (typeof window.triggerGokwikCustomCheckout === 'function') window.triggerGokwikCustomCheckout();
        else window.location.href = '/checkout';
      })
      .catch(function(err){ console.error('[principal] hotfix buy fallback failed:', err); });
  }, true);  // capture phase = beats anything else that might preventDefault

  // === Helper: only-when-visible animation pause ===
  function pauseWhenOffscreen(selector, attr) {
    var el = document.querySelector(selector);
    if (!el || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) el.removeAttribute(attr);
        else el.setAttribute(attr, 'true');
      });
    }, { threshold: 0.05 });
    io.observe(el);
  }
  pauseWhenOffscreen('.cn1-trustbar', 'data-paused');
  pauseWhenOffscreen('.cn1-rev-rows', 'data-paused');
  document.querySelectorAll('.cn1-cta-primary').forEach(function(el){
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) el.removeAttribute('data-paused');
        else el.setAttribute('data-paused','true');
      });
    }, { threshold: 0.05 });
    io.observe(el);
  });

  // === Scroll progress (rAF-throttled — fixes design-taste #1) ===
  var prog = document.getElementById('gnProgress');
  if (prog) {
    var ticking = false;
    function updateProg() {
      var h = document.documentElement;
      var st = h.scrollTop || document.body.scrollTop;
      var sh = (h.scrollHeight || document.body.scrollHeight) - h.clientHeight;
      prog.style.width = sh > 0 ? (st / sh * 100) + '%' : '0%';
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if (!ticking) {
        requestAnimationFrame(updateProg);
        ticking = true;
      }
    }, { passive: true });
  }

  // === Countdown timer removed in v12 — top strip is now a trust marquee ===

  // === Pause marquee when off-screen (perf) ===
  pauseWhenOffscreen('.cn1-marquee', 'data-paused');

  // === Fade-up on scroll ===
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.cn1-fu').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.cn1-fu').forEach(function(el){ el.classList.add('in'); });
  }

  // === Master tick — consolidates 3 setIntervals into one (Medium fix) ===
  var liveAbove = document.getElementById('liveAboveFold');
  var liveStick = document.getElementById('liveCount');
  var liveN = 142;

  var buyers = [
    { n: 'Riya from Mumbai',     t: 'just bought 3 minutes ago' },
    { n: 'Aarav from Pune',      t: 'just bought 5 minutes ago' },
    { n: 'Priya from Bengaluru', t: 'just bought 8 minutes ago' },
    { n: 'Karan from Delhi',     t: 'just bought 12 minutes ago' },
    { n: 'Sneha from Kochi',     t: 'just bought 15 minutes ago' },
    { n: 'Vikram from Chennai',  t: 'just bought 22 minutes ago' },
    { n: 'Rahul from Jaipur',    t: 'just bought 28 minutes ago' }
  ];
  var toast = document.getElementById('buyerToast');
  var tName = document.getElementById('toastName');
  var tMsg  = document.getElementById('toastMsg');
  var bi = 0;
  function showToast() {
    if (!toast || !tName || !tMsg) return;  // P0 fix 2026-05-20: guard nulls on principal-* pages (no toast section)
    var b = buyers[bi % buyers.length];
    tName.textContent = b.n;
    tMsg.textContent = b.t;
    toast.classList.add('show');
    setTimeout(function(){ toast.classList.remove('show'); }, 4200);
    bi++;
  }
  // First toast at ~5.5s; thereafter every 11s — only schedule if toast exists
  if (document.getElementById('toastName')) {
    setTimeout(showToast, 5500);
    setInterval(showToast, 11000);
  }

  // Live viewer ticker — 4s cadence, 60% chance to change ±2 (occasional ±3), range 100-200
  setInterval(function(){
    if (Math.random() <= 0.40) return; // 60% chance we update
    var sign = Math.random() < 0.5 ? -1 : 1;
    var step = Math.random() < 0.18 ? 3 : 2; // ~18% chance of ±3
    liveN = Math.max(100, Math.min(200, liveN + sign * step));
    [liveAbove, liveStick].forEach(function(el){
      if (!el) return;
      el.textContent = liveN;
      // re-trigger animation
      el.classList.remove('flash');
      void el.offsetWidth; /* reflow */
      el.classList.add('flash');
    });
  }, 4000);
  // (Toast interval moved into guarded block above — removed duplicate call here)

  // === Drag scroll for Problem + Features ===
  function attachDrag(elId) {
    var el = document.getElementById(elId);
    if (!el) return;
    var down = false, sx, sl, vx = 0, lx, lt, raf;
    el.addEventListener('mousedown', function(e){
      down = true; sx = e.pageX; sl = el.scrollLeft;
      vx = 0; lx = e.pageX; lt = Date.now();
      el.classList.add('dragging');
      cancelAnimationFrame(raf);
    });
    window.addEventListener('mouseup', function(){
      if (!down) return;
      down = false;
      el.classList.remove('dragging');
      cancelAnimationFrame(raf);
      (function g(){
        if (Math.abs(vx) < 0.4) return;
        el.scrollLeft -= vx;
        vx *= 0.91;
        raf = requestAnimationFrame(g);
      })();
    });
    window.addEventListener('mousemove', function(e){
      if (!down) return;
      e.preventDefault();
      var now = Date.now(), dt = Math.max(1, now - lt);
      vx = (e.pageX - lx) / dt * 14;
      lx = e.pageX; lt = now;
      el.scrollLeft = sl - (e.pageX - sx);
    }, { passive: false });
  }
  // R4 fix: bare-ID attachDrag calls were no-ops — Shopify suffixes IDs with section.id.
  // Apply drag (Problem) and marquee+drag (Features) to all matching suffixed elements.
  document.querySelectorAll('[id^="probScroll-"]').forEach(function(el){
    var down = false, sx = 0, sl = 0, vx = 0, lx = 0, lt = 0, raf;
    el.addEventListener('mousedown', function(e){
      down = true; sx = e.pageX; sl = el.scrollLeft;
      lx = e.pageX; lt = Date.now(); vx = 0;
      el.classList.add('dragging');
    });
    window.addEventListener('mouseup', function(){
      if (!down) return;
      down = false; el.classList.remove('dragging');
      cancelAnimationFrame(raf);
      (function decay(){
        if (Math.abs(vx) < 0.4) return;
        el.scrollLeft -= vx; vx *= 0.91;
        raf = requestAnimationFrame(decay);
      })();
    });
    window.addEventListener('mousemove', function(e){
      if (!down) return;
      e.preventDefault();
      var now = Date.now(), dt = Math.max(1, now - lt);
      vx = (e.pageX - lx) / dt * 14; lx = e.pageX; lt = now;
      el.scrollLeft = sl - (e.pageX - sx);
    }, { passive: false });
  });

  // Features: continuous auto-marquee + drag-to-scrub (same pattern as Solution).
  document.querySelectorAll('[id^="featScroll-"]').forEach(function(scroll){
    var track = scroll.querySelector('.cn1-feat-track');
    if (!track) return;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReducedMotion) {
      var pauseUntil = 0;
      var scrollAccum = scroll.scrollLeft;
      var SPEED = 0.5;
      var marqueeRaf = null;
      function tick() {
        if (Date.now() >= pauseUntil && !document.hidden) {
          var max = scroll.scrollWidth - scroll.clientWidth;
          if (max > 1) {
            scrollAccum += SPEED;
            if (scrollAccum >= max - 1) { scrollAccum = 0; scroll.scrollLeft = 0; }
            else { scroll.scrollLeft = Math.round(scrollAccum); }
          }
        } else {
          scrollAccum = scroll.scrollLeft;
        }
        marqueeRaf = requestAnimationFrame(tick);
      }
      marqueeRaf = requestAnimationFrame(tick);
      // R5.2: drag handler on DESKTOP MOUSE only. On touch devices, the JS scrubbing
      // fights native iOS momentum (custom decay 0.92 is ~3x weaker than iOS native),
      // so fast flicks barely advance one card. Touch path: pause marquee, let native
      // momentum scroll do its thing, resume marquee 4s after touchend.
      var isDown = false, startX = 0, startScroll = 0, vx = 0, lastX = 0, lastT = 0, momRaf;
      var supportsTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
      function onMouseDown(e) {
        isDown = true;
        pauseUntil = Date.now() + 9999999;
        scroll.classList.add('dragging');
        startX = e.pageX; lastX = e.pageX; lastT = Date.now();
        startScroll = scroll.scrollLeft; vx = 0;
        cancelAnimationFrame(momRaf);
      }
      function onMouseMove(e) {
        if (!isDown) return;
        var now = Date.now(), dt = Math.max(1, now - lastT);
        vx = (e.pageX - lastX) / dt * 14; lastX = e.pageX; lastT = now;
        scroll.scrollLeft = startScroll - (e.pageX - startX);
      }
      function onMouseUp() {
        if (!isDown) return;
        isDown = false;
        scroll.classList.remove('dragging');
        pauseUntil = Date.now() + 4000;
        (function decay(){
          if (Math.abs(vx) < 0.4) return;
          scroll.scrollLeft -= vx; vx *= 0.92;
          momRaf = requestAnimationFrame(decay);
        })();
      }
      if (!supportsTouch) {
        scroll.addEventListener('mousedown', onMouseDown);
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
      } else {
        scroll.addEventListener('touchstart', function(){
          pauseUntil = Date.now() + 9999999;
          scrollAccum = scroll.scrollLeft;
        }, { passive: true });
        scroll.addEventListener('touchend', function(){
          pauseUntil = Date.now() + 4000;
          setTimeout(function(){ scrollAccum = scroll.scrollLeft; }, 200);
        }, { passive: true });
      }
    }
  });

  // R4.5: scroll-driven active-card tracking for HowItWorks + Features.
  // Same pattern as Solution: compares card centers to viewport center, toggles .is-active.
  // Native momentum scrolling stays untouched — this only reads scroll position.
  var __activeSyncs = [];
  function attachActiveTracker(trackSelector, cardSelector) {
    document.querySelectorAll(trackSelector).forEach(function(track){
      var cards = Array.prototype.slice.call(track.querySelectorAll(cardSelector));
      if (!cards.length) return;
      function activeIndex() {
        var min = Infinity, idx = 0;
        var viewCenter = track.scrollLeft + track.clientWidth / 2;
        cards.forEach(function(c, i){
          var cardCenter = c.offsetLeft + c.offsetWidth / 2;
          var d = Math.abs(cardCenter - viewCenter);
          if (d < min) { min = d; idx = i; }
        });
        return idx;
      }
      function syncActive() {
        // Desktop / grid layouts aren't horizontally scrollable — don't pin an "active" card there (hover drives desktop).
        if (track.scrollWidth <= track.clientWidth + 4) {
          cards.forEach(function(c){ c.classList.remove('is-active'); });
          return;
        }
        var i = activeIndex();
        cards.forEach(function(c, ci){ c.classList.toggle('is-active', ci === i); });
      }
      // rAF-throttle so native momentum scroll doesn't fire syncActive on every frame.
      var rafPending = false;
      function onScroll() {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(function(){ rafPending = false; syncActive(); });
      }
      track.addEventListener('scroll', onScroll, { passive: true });
      // Initial state
      syncActive();
      __activeSyncs.push(syncActive);
      // Tap any card to scroll-to-center (active follows)
      cards.forEach(function(card){
        card.addEventListener('click', function(){
          var cardCenter = card.offsetLeft + card.offsetWidth / 2;
          var targetScroll = cardCenter - track.clientWidth / 2;
          track.scrollTo({ left: targetScroll, behavior: 'smooth' });
        });
      });
    });
  }
  // Live mobile-scroll active-card highlight (centred card spotlights as you swipe).
  // Only the free-scroll (overflow-x:auto) sections — How-It-Works is a transform-nav carousel with its own dots/arrows.
  attachActiveTracker('#principal-prob-scroll', '.principal-prob-card');
  attachActiveTracker('#principal-feat-scroll', '.principal-feat-card');
  // Re-evaluate the active card on viewport resize / rotate (scroll may not fire on its own).
  var __activeResizeT;
  window.addEventListener('resize', function(){
    clearTimeout(__activeResizeT);
    __activeResizeT = setTimeout(function(){ __activeSyncs.forEach(function(fn){ fn(); }); }, 150);
  }, { passive: true });

  // === HowItWorks progress bar ===
  var howTrack = document.getElementById('howTrack');
  var howProgress = document.getElementById('howProgress');
  if (howTrack && howProgress) {
    howTrack.addEventListener('scroll', function(){
      var max = howTrack.scrollWidth - howTrack.clientWidth;
      var pct = max > 0 ? Math.min(100, Math.max(33, 33 + (howTrack.scrollLeft / max) * 67)) : 33;
      howProgress.style.width = pct + '%';
    }, { passive: true });
  }

  // === FAQ toggle ===
  document.querySelectorAll('[data-faq] .cn1-faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('[data-faq]');
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // R4.8: cn1-cmp4 card scroll-trigger — adds .is-visible to fire staggered row + icon reveals
  if ('IntersectionObserver' in window) {
    var cmp4Io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        cmp4Io.unobserve(e.target);
      });
    }, { threshold: 0.20, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-cmp-card]').forEach(function(el){ cmp4Io.observe(el); });
  } else {
    document.querySelectorAll('[data-cmp-card]').forEach(function(el){ el.classList.add('is-visible'); });
  }

  // === Comparison animation — per-section (IDs are suffixed with section.id) ===
  if ('IntersectionObserver' in window) {
    document.querySelectorAll('[id^="cmpTable-"]').forEach(function(cmp){
      var cmpIo = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!e.isIntersecting) return;
          var crosses = cmp.querySelectorAll('.cn1-cmp-icon-them');
          var checks  = cmp.querySelectorAll('.cn1-cmp-icon-us');
          var thems   = cmp.querySelectorAll('.cn1-cmp-them');
          thems.forEach(function(t){ setTimeout(function(){ t.classList.add('dimmed'); }, 200); });
          crosses.forEach(function(c, i){ setTimeout(function(){ c.classList.add('show'); }, 300 + i * 100); });
          checks.forEach(function(c, i){ setTimeout(function(){ c.classList.add('show'); }, 900 + i * 160); });
          cmpIo.unobserve(cmp);
        });
      }, { threshold: 0.2 });
      cmpIo.observe(cmp);
    });
  }

  // === Problem popout pop-in on scroll-into-view ===
  if ('IntersectionObserver' in window) {
    var popoutIo = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        e.target.classList.add('is-popped');
        popoutIo.unobserve(e.target);
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('[data-popout]').forEach(function(el){ popoutIo.observe(el); });
  } else {
    document.querySelectorAll('[data-popout]').forEach(function(el){ el.classList.add('is-popped'); });
  }

  // === Stat count-up ===
  if ('IntersectionObserver' in window) {
    var statsIo = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var counter = e.target.querySelector('.cn1-counter');
        if (!counter) return;
        var target = parseInt(counter.getAttribute('data-target'), 10);
        var t0 = performance.now(), dur = 1400;
        function step(t){
          var p = Math.min(1, (t - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          counter.textContent = Math.floor(target * eased).toLocaleString('en-IN');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        statsIo.unobserve(e.target);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.cn1-stat-num .cn1-counter').forEach(function(el){ statsIo.observe(el.closest('.cn1-stat-num')); });
  }

  // === Sticky CTA shake — once per dwell, not infinite ===
  var stickyCta = document.getElementById('stickyCta');
  if (stickyCta && 'IntersectionObserver' in window) {
    var bumped = false;
    var actionSection = document.querySelector('.cn1-action');
    if (actionSection) {
      var stickyIo = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting && !bumped) {
            stickyCta.setAttribute('data-shake', 'true');
            bumped = true;
            setTimeout(function(){ stickyCta.removeAttribute('data-shake'); }, 500);
          }
        });
      }, { threshold: 0.2 });
      stickyIo.observe(actionSection);
    }
  }

  // === Calculator fallback — ensure rows reveal even without GSAP / on reduced-motion ===
  (function(){
    var calc = document.querySelector('.cn1-calc');
    if (!calc) return;
    var rows = calc.querySelectorAll('.cn1-calc-row');
    var banner = document.querySelector('.cn1-calc-banner');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function reveal() {
      rows.forEach(function(r){ r.classList.add('is-revealed'); });
      if (banner) banner.classList.add('is-popped');
    }
    if (reduced) { reveal(); return; }
    // R4.4: shorter fallback (1.8s → 0.6s). If GSAP didn't reveal by then, force it.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!e.isIntersecting) return;
          setTimeout(function(){
            if (rows[0] && !rows[0].classList.contains('is-revealed')) reveal();
          }, 600);
          io.disconnect();
        });
      }, { threshold: 0.15 });
      io.observe(calc);
    } else {
      reveal();
    }
  })();

  // === Solution carousel — continuous auto-marquee + drag-to-scrub (all viewports) ===
  document.querySelectorAll('[id^="solTrack-"]').forEach(function(track){
    var sectionSuffix = track.id.replace('solTrack-', '');
    var dotsWrap = document.getElementById('solDots-' + sectionSuffix);
    var cards = Array.prototype.slice.call(track.querySelectorAll('.cn1-sol-card'));
    if (!cards.length) return;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Build dot indicators
    if (dotsWrap) {
      cards.forEach(function(_, i){
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cn1-sol-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Show benefit ' + (i + 1) + ' of ' + cards.length);
        dot.addEventListener('click', function(){
          track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          pauseUntil = Date.now() + 4000;
        });
        dotsWrap.appendChild(dot);
      });
    }
    var dots = dotsWrap ? dotsWrap.querySelectorAll('.cn1-sol-dot') : [];

    /* R4.3: activeIndex now compares CARD CENTERS to viewport center
       (was comparing left edges, broken under center-snap). */
    function activeIndex() {
      var min = Infinity, idx = 0;
      var viewCenter = track.scrollLeft + track.clientWidth / 2;
      cards.forEach(function(c, i){
        var cardCenter = c.offsetLeft + c.offsetWidth / 2;
        var d = Math.abs(cardCenter - viewCenter);
        if (d < min) { min = d; idx = i; }
      });
      return idx;
    }
    function syncActive() {
      var i = activeIndex();
      dots.forEach(function(d, di){ d.classList.toggle('is-active', di === i); });
      // R4.3: also toggle .is-active on the cards themselves so CSS dim/highlight kicks in
      cards.forEach(function(c, ci){ c.classList.toggle('is-active', ci === i); });
    }
    track.addEventListener('scroll', syncActive, { passive: true });
    // Initial active-state on load (otherwise everything stays dim until first scroll)
    syncActive();

    if (prefersReducedMotion) return;

    // Continuous auto-marquee — accumulates subpixel float, applies on integer crossing
    var pauseUntil = 0;
    var scrollAccum = track.scrollLeft;
    var raf = null;
    var SPEED = 0.6; // px per frame ~ 36px/sec at 60fps
    function tick() {
      if (Date.now() >= pauseUntil && !document.hidden) {
        var max = track.scrollWidth - track.clientWidth;
        if (max > 1) {
          scrollAccum += SPEED;
          if (scrollAccum >= max - 1) {
            scrollAccum = 0;
            track.scrollLeft = 0;
          } else {
            track.scrollLeft = Math.round(scrollAccum);
          }
        }
      } else {
        scrollAccum = track.scrollLeft;
      }
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);

    // R5.2: drag handler on DESKTOP MOUSE only. On touch, the JS scrubbing fights
    // native iOS momentum (custom decay 0.92 is ~3x weaker than iOS native), making
    // fast flicks feel laggy. Touch path: pause marquee on touchstart, native scroll
    // does the heavy lifting, marquee resumes 4s after touchend.
    var isDown = false, startX = 0, startScroll = 0, vx = 0, lastX = 0, lastT = 0, momRaf;
    var supportsTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    function onMouseDown(e) {
      isDown = true;
      pauseUntil = Date.now() + 9999999;
      track.classList.add('dragging');
      startX = e.pageX; lastX = e.pageX; lastT = Date.now();
      startScroll = track.scrollLeft; vx = 0;
      cancelAnimationFrame(momRaf);
    }
    function onMouseMove(e) {
      if (!isDown) return;
      var now = Date.now(), dt = Math.max(1, now - lastT);
      vx = (e.pageX - lastX) / dt * 14; lastX = e.pageX; lastT = now;
      track.scrollLeft = startScroll - (e.pageX - startX);
    }
    function onMouseUp() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('dragging');
      pauseUntil = Date.now() + 4000;
      (function decay(){
        if (Math.abs(vx) < 0.4) return;
        track.scrollLeft -= vx; vx *= 0.92;
        momRaf = requestAnimationFrame(decay);
      })();
    }
    if (!supportsTouch) {
      track.addEventListener('mousedown', onMouseDown);
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    } else {
      track.addEventListener('touchstart', function(){
        pauseUntil = Date.now() + 9999999;
        scrollAccum = track.scrollLeft;
      }, { passive: true });
      track.addEventListener('touchend', function(){
        pauseUntil = Date.now() + 4000;
        setTimeout(function(){ scrollAccum = track.scrollLeft; }, 200);
      }, { passive: true });
    }
  });

  // === Card click handler ===
  // Solution: scroll-to-center on click (auto-highlight follows via the scroll IO).
  // Problem/HowItWorks/Features: simple toggle (no auto-marquee on those tracks).
  ['.cn1-sol-track', '.cn1-prob-track', '.cn1-how-track', '.cn1-feat-track'].forEach(function(selector){
    document.querySelectorAll(selector).forEach(function(track){
      var isSolTrack = selector === '.cn1-sol-track';
      track.querySelectorAll('.cn1-sol-card, .cn1-prob-card, .cn1-how-card, .cn1-feat-card').forEach(function(card){
        card.addEventListener('click', function(e){
          if (track.classList.contains('dragging')) return;
          if (isSolTrack) {
            // Scroll card to center; the scroll IO will set .is-active automatically
            var cardCenter = card.offsetLeft + card.offsetWidth / 2;
            var targetScroll = cardCenter - track.clientWidth / 2;
            track.scrollTo({ left: targetScroll, behavior: 'smooth' });
          } else {
            track.querySelectorAll('.is-active').forEach(function(c){ c.classList.remove('is-active'); });
            card.classList.add('is-active');
          }
        });
      });
    });
  });

  // === Buy-intent handler — AJAX cart + GoKwik custom checkout ===
  // Bypasses Kaching Bundles by avoiding form submission entirely.
  // Flow: clear cart -> add line items via /cart/add.js -> trigger GoKwik modal.
  //
  // Variant resolution priority (per button click):
  //   1. data-variant-ids="111,222"      (Kit combos, multi-line cart)
  //   2. data-variant-id="111"           (Hero pack option, Bundle radio, etc.)
  //   3. data-bundle-source="<group>"    (Bundle CTA reads selected radio[name=group])
  //   4. selected hero pack radio with [data-variant-id]
  //   5. fallback to #cn1BuyMeta.dataset.variantId (page-level default = current product)
  function principalFallbackVariantId() {
    var meta = document.getElementById('cn1BuyMeta');
    return meta && meta.dataset.variantId ? parseInt(meta.dataset.variantId, 10) : null;
  }
  function principalReadHeroPackVariant() {
    var checked = document.querySelector('input[name="heroPack"]:checked');
    if (!checked) return null;
    var v = checked.dataset.variantId;
    return v ? parseInt(v, 10) : null;
  }
  function principalResolveLineItems(btn) {
    // Returns an array of { id, quantity } objects.
    // stepperMult = the multiplier set by the qty stepper / sticky-bar <select>. Always honor it.
    var stepperMult = Math.max(1, parseInt(btn.dataset.buyQty || '1', 10));
    // 1. multi-line: data-variant-ids (comma-separated)
    var multi = (btn.dataset.variantIds || '').trim();
    if (multi) {
      var ids = multi.split(',').map(function(s){ return parseInt(s.trim(), 10); }).filter(Boolean);
      if (ids.length) return ids.map(function(id){ return { id: id, quantity: 1 }; });
    }
    // 2. single explicit variant on the button
    var explicit = btn.dataset.variantId ? parseInt(btn.dataset.variantId, 10) : null;
    if (explicit) return [{ id: explicit, quantity: stepperMult }];

    // 3. Bundle CTA — read currently checked radio in named group; final qty = radio.qty × stepper
    var bundleSource = btn.dataset.bundleSource;
    if (bundleSource) {
      var checked = document.querySelector('input[name="' + bundleSource + '"]:checked');
      if (checked) {
        var bv = checked.dataset.variantId ? parseInt(checked.dataset.variantId, 10) : null;
        var bq = Math.max(1, parseInt(checked.dataset.qty || '1', 10));
        var finalQty = bq * stepperMult;
        if (bv) return [{ id: bv, quantity: finalQty }];
        // Variant not specified on this radio → fall back to page default + multiplied qty
        var fb = principalFallbackVariantId();
        if (fb) return [{ id: fb, quantity: finalQty }];
      }
    }

    // 4. Hero pack picker — selected radio's variant id (if any) × stepper
    var heroVar = principalReadHeroPackVariant();
    if (heroVar) {
      var heroQty = Math.max(1, parseInt(document.querySelector('input[name="heroPack"]:checked').dataset.qty || '1', 10));
      return [{ id: heroVar, quantity: heroQty * stepperMult }];
    }

    // 5. Fallback to page-level default variant
    var fbId = principalFallbackVariantId();
    if (fbId) return [{ id: fbId, quantity: stepperMult }];
    return null;
  }
  function principalAjaxClearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
  }
  function principalAjaxAddItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    });
  }
  function gnGokwikCheckout(btn) {
    if (typeof window.triggerGokwikCustomCheckout === 'function') {
      try { window.triggerGokwikCustomCheckout(); return true; } catch(e) { console.error('[cn1] triggerGokwikCustomCheckout failed:', e); }
    }
    if (typeof window.gokwikCheckoutClickFn === 'function') {
      try { window.gokwikCheckoutClickFn(btn); return true; } catch(e) { console.error('[cn1] gokwikCheckoutClickFn failed:', e); }
    }
    if (typeof window.gokwikBuyNowClickFn === 'function') {
      try { window.gokwikBuyNowClickFn(btn); return true; } catch(e) { console.error('[cn1] gokwikBuyNowClickFn failed:', e); }
    }
    return false;
  }
  function gnUpdateCartUI(itemCountDelta) {
    // Bump common cart-count selectors used in Kalles/header
    var selectors = ['.cart-count', '.t4s-cart-count', '[data-cart-count]', '.header__cart-count', '.cart-counter'];
    var bumped = false;
    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        var n = parseInt((el.textContent || '0').replace(/[^0-9]/g, ''), 10) || 0;
        el.textContent = (n + itemCountDelta);
        bumped = true;
      });
    });
    return bumped;
  }
  function gnShowCartToast(message) {
    var existing = document.getElementById('gnCartToast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.id = 'gnCartToast';
    t.className = 'cn1-cart-toast';
    t.innerHTML = '<svg aria-hidden="true" width="18" height="18"><use href="#i-check"/></svg>' +
                  '<span>' + message + '</span>' +
                  '<a href="/cart" class="cn1-cart-toast-link">View cart</a>';
    document.body.appendChild(t);
    requestAnimationFrame(function(){ t.classList.add('show'); });
    setTimeout(function(){ t.classList.remove('show'); setTimeout(function(){ t.remove(); }, 400); }, 3500);
  }
  // === Checkout speed (2026-09-15, QA round 2) =================================================
  // Measured 15 Sep at 390 px: tap -> GoKwik took 2.0-3.2 s. POST /cart/clear.js alone was
  // 0.7-1.2 s, and ad visitors almost always arrive with an empty cart. Changes:
  //   1. pcsPrepareCart(): live GET /cart.js, clear only when it holds items (any doubt -> clear).
  //   2. pcsLock()/pcsUnlock(): page-wide lock from tap until GoKwik is visible (or failure / 12 s).
  //   3. Busy overlay sized to the button, plus Clarity timing events.
  function pcsPrepareCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ return (c && c.item_count === 0) ? 'empty' : principalAjaxClearCart(); })
      .catch(function(){ return principalAjaxClearCart(); });
  }
  var pcsT0 = 0;
  function pcsMark(name) {
    try {
      if (!window.clarity) return;
      var ms = pcsT0 ? Math.round(performance.now() - pcsT0) : 0;
      var bucket = ms < 500 ? '0-0.5s' : ms < 1000 ? '0.5-1s' : ms < 2000 ? '1-2s' : ms < 3000 ? '2-3s' : '3s+';
      window.clarity('event', name);
      if (name !== 'vn_tap') window.clarity('set', name + '_time', bucket);
    } catch (e) {}
  }
  var pcsTimer = null, pcsBtn = null, pcsSeq = 0, pcsInFlight = false, pcsLockedAt = 0;
  function pcsLock(btn) {
    pcsSeq++; window.__pcsBusy = true; pcsBtn = btn; pcsInFlight = true; pcsLockedAt = performance.now();
    try {
      var r = btn.getBoundingClientRect();
      btn.style.width = r.width + 'px'; btn.style.height = r.height + 'px';
      btn.setAttribute('data-pcs-label', r.width >= 230 ? 'Opening secure checkout' : 'Opening…');
      btn.classList.add('pcs-busy'); btn.setAttribute('aria-busy', 'true');
    } catch (e) {}
    clearTimeout(pcsTimer);
    pcsTimer = setTimeout(pcsSafetyRelease, 12000); // never strand the page if a request hangs
    return pcsSeq;
  }
  function pcsSafetyRelease() {
    // A cart request still pending: a re-tap now would read an empty cart and add a second pack.
    // Keep the lock until it settles, with a hard cap at 30 s.
    if (pcsInFlight && performance.now() - pcsLockedAt < 30000) { pcsTimer = setTimeout(pcsSafetyRelease, 1000); return; }
    pcsUnlock();
  }
  function pcsUnlock(seq) {
    if (seq !== undefined && seq !== pcsSeq) return; // a late callback from an earlier tap
    clearTimeout(pcsTimer); pcsTimer = null; pcsInFlight = false;
    window.__pcsBusy = false;
    var b = pcsBtn; pcsBtn = null;
    if (!b) return;
    b.classList.remove('pcs-busy', 'is-loading'); b.removeAttribute('aria-busy');
    b.style.width = ''; b.style.height = ''; b.removeAttribute('data-pcs-label');
  }
  function pcsUnlockWhenGokwikVisible(seq) {
    var start = performance.now();
    (function poll(){
      var frames = document.querySelectorAll('iframe[src*="gokwik"]');
      for (var i = 0; i < frames.length; i++) {
        var fr = frames[i].getBoundingClientRect();
        if (fr.height > 200 && fr.width > 200 && getComputedStyle(frames[i]).visibility !== 'hidden') {
          pcsMark('vn_gokwik_open'); pcsUnlock(seq); return;
        }
      }
      if (performance.now() - start < 10000) setTimeout(poll, 100); else pcsUnlock(seq);
    })();
  }
  window.addEventListener('pageshow', function(e){ if (e.persisted) pcsUnlock(); }); // back button from /checkout
  if (document.querySelector('[data-buy]') && !document.getElementById('pcs-busy-style')) {
    var pcsSt = document.createElement('style'); pcsSt.id = 'pcs-busy-style';
    pcsSt.textContent =
      '[data-buy].pcs-busy{position:relative;box-sizing:border-box;pointer-events:none;font-size:0 !important;overflow:hidden}' +
      '[data-buy].pcs-busy>*{visibility:hidden}' +
      '[data-buy].pcs-busy::after{content:attr(data-pcs-label);position:absolute;inset:0;display:flex;align-items:center;' +
        'justify-content:center;padding:0 8px 0 30px;background:inherit;border-radius:inherit;color:#fff;font-size:13px;' +
        'font-weight:600;line-height:1.1;white-space:nowrap;visibility:visible;animation:none;z-index:1}' +
      '[data-buy].pcs-busy::before{content:"";position:absolute;top:50%;left:12px;width:14px;height:14px;margin-top:-7px;' +
        'border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:pcs-spin .8s linear infinite;' +
        'visibility:visible;z-index:2}' +
      '@keyframes pcs-spin{to{transform:rotate(360deg)}}' +
      '@media (prefers-reduced-motion: reduce){[data-buy].pcs-busy::before{animation:none}}';
    document.head.appendChild(pcsSt);
  }

  function principalBuyClick(btn) {
    var mode = (btn.getAttribute('data-buy') || '').toLowerCase(); // "cart" or "" (= checkout)
    var items = principalResolveLineItems(btn);
    if (!items || !items.length) {
      console.error('[cn1] no line items resolved for buy click', btn);
      var target = document.querySelector('.cn1-action');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (window.__pcsBusy) return; // backstop: the body delegation already checks this
    if (mode === 'cart' && btn.classList.contains('is-loading')) return; // add-to-cart double tap
    btn.classList.add('is-loading');
    var pcsMySeq = 0;
    if (mode !== 'cart') { pcsMySeq = pcsLock(btn); pcsT0 = performance.now(); pcsMark('vn_tap'); }

    if (mode === 'cart') {
      // Add-to-cart only: no clear, no GoKwik, just update UI
      principalAjaxAddItems(items)
        .then(function(r){ return r.json(); })
        .then(function(data){
          if (data && data.status >= 400) throw new Error(data.description || 'cart add failed');
          var totalQty = items.reduce(function(s, it){ return s + (it.quantity || 1); }, 0);
          gnUpdateCartUI(totalQty);
          // Open the cart drawer on a successful add so the bundle addition shows in
          // the reward progress bar. No-op if the drawer snippet is not on the page.
          if (typeof window.pcartOpen === 'function') { window.pcartOpen(); }
          else { gnShowCartToast('Added to cart · ' + totalQty + ' item' + (totalQty > 1 ? 's' : '')); }
        })
        .catch(function(err){
          console.error('[cn1] AJAX cart-add error:', err);
          gnShowCartToast('Could not add to cart. Try again.');
        })
        .finally(function(){
          btn.classList.remove('is-loading');
        });
      return;
    }

    // Cart-drawer intercept (flag + product-allowlisted via the drawer snippet, which sets
    // window.PCART_INTERCEPT). When ON: Buy Now becomes clear → add → open the drawer
    // (merchandise before checkout) instead of jumping straight to GoKwik. This stays INSIDE
    // the single [data-buy] handler — no second listener — so the §16 single-handler invariant
    // (one principalBuyClick per click) is preserved.
    if (window.PCART_INTERCEPT === true && typeof window.pcartOpen === 'function') {
      pcsPrepareCart()
        .then(function(){ return principalAjaxAddItems(items); })
        .then(function(r){ return r.json(); })
        .then(function(data){
          if (data && data.status >= 400) throw new Error(data.description || 'cart add failed');
          pcsInFlight = false;
          pcsMark('vn_cart_added');
          window.pcartOpen();
          pcsUnlock(pcsMySeq); // the drawer is visible now; nothing else is in flight
        })
        .catch(function(err){
          console.error('[cn1] cart-drawer intercept failed, falling back to direct checkout:', err);
          // fail-safe: a cart error must never strand the buyer — fall back to the normal GoKwik path
          pcsInFlight = false;
          if (gnGokwikCheckout(btn)) pcsUnlockWhenGokwikVisible(pcsMySeq); else window.location.href = '/checkout';
        })
        .finally(function(){ btn.classList.remove('is-loading'); });
      return;
    }

    // Default: full checkout flow (clear → add → GoKwik)
    pcsPrepareCart()
      .then(function(){ return principalAjaxAddItems(items); })
      .then(function(r){ return r.json(); })
      .then(function(data){
        if (data && data.status >= 400) throw new Error(data.description || 'cart add failed');
        pcsInFlight = false;
        pcsMark('vn_cart_added');
        if (gnGokwikCheckout(btn)) {
          pcsUnlockWhenGokwikVisible(pcsMySeq);
        } else {
          window.location.href = '/checkout'; // page unloads; lock released by the 12 s timer if it does not
        }
      })
      .catch(function(err){
        pcsUnlock(pcsMySeq);
        console.error('[cn1] AJAX buy error:', err);
        var target = document.querySelector('.cn1-action');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .finally(function(){
        btn.classList.remove('is-loading');
      });
  }
  /* Expose so principal-utilities.js's principalBuyClick can short-circuit to this when present.
     VC (VibeCam) pages only load principal-utilities.js, so principalBuyClick keeps its fallback body. */
  window.principalBuyClick = principalBuyClick;
  /* 2026-05-27: removed the direct per-button click listener that lived here. The body-level
     delegation at the top of this IIFE already calls window.principalBuyClick on every [data-buy]
     click. Keeping the duplicate caused principalBuyClick to run twice per click → 2 racing
     /cart/add.js calls → Shopify merged them and customers were charged 2× the picked pack qty. */

  // === Scroll-to anchor handler (rating row → Reviews, See-it-fold → How it works, etc.) ===
  document.querySelectorAll('[data-scroll-to]').forEach(function(el){
    el.addEventListener('click', function(e){
      var target = document.querySelector(el.dataset.scrollTo);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
  // Enable CTAs once GoKwik SDK is ready
  function gnEnableBuyCtas() {
    // Skip CTAs the mix-pack picker disabled for an unresolved/unminted combo (.is-unavailable)
    // so they stay visually + behaviourally disabled after the SDK loads (no case-4 over-bill).
    document.querySelectorAll('[data-buy]:not(.is-unavailable)').forEach(function(b){
      b.disabled = false;
      b.classList.remove('disabled');
    });
  }
  window.addEventListener('gokwikLoaded', gnEnableBuyCtas);
  // CTAs are click-actionable even before SDK loads (cart.js still works)
  gnEnableBuyCtas();

  // === Hero gallery — Flickity init + tap-to-zoom lightbox ===
  (function(){
    var gallery = document.getElementById('heroGallery');
    var dialog  = document.getElementById('galleryZoom');
    if (!gallery || !dialog) return;

    var stage = document.getElementById('galleryZoomStage');
    var zImg  = document.getElementById('galleryZoomImg');
    var closeBtn = dialog.querySelector('[data-zoom-close]');

    // Wait for Flickity to load (it's deferred); poll briefly
    var tries = 0;
    var pollFlickity = setInterval(function(){
      tries++;
      if (typeof Flickity === 'undefined') {
        if (tries > 80) clearInterval(pollFlickity); // give up after 8s
        return;
      }
      clearInterval(pollFlickity);
      // Flickity auto-inits via data-flickity attribute, but ensure resize after fonts settle
      setTimeout(function(){
        try { Flickity.data(gallery)?.resize(); } catch(e){}
      }, 400);
    }, 100);

    // Tap any cell -> open zoom dialog with that cell's image
    gallery.addEventListener('click', function(e){
      var cell = e.target.closest('.cn1-gallery-cell');
      if (!cell) return;
      // ignore drag-clicks (Flickity sets is-pointer-down briefly)
      if (gallery.classList.contains('is-pointer-down')) return;
      var img = cell.querySelector('img');
      if (!img) return;
      zImg.src = img.currentSrc || img.src;
      zImg.alt = img.alt || '';
      zImg.style.transform = 'translate(0,0) scale(1)';
      zoomState.scale = 1; zoomState.tx = 0; zoomState.ty = 0;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    });

    closeBtn.addEventListener('click', function(){ dialog.close ? dialog.close() : dialog.removeAttribute('open'); });
    dialog.addEventListener('click', function(e){ if (e.target === dialog) (dialog.close ? dialog.close() : dialog.removeAttribute('open')); });

    // Pinch + pan + double-tap zoom in lightbox
    var zoomState = { scale: 1, tx: 0, ty: 0 };
    var lastTouch = 0;
    var pinchStart = null;
    var dragStart = null;

    function applyTransform() {
      zImg.style.transform = 'translate(' + zoomState.tx + 'px,' + zoomState.ty + 'px) scale(' + zoomState.scale + ')';
    }

    stage.addEventListener('touchstart', function(e){
      if (e.touches.length === 2) {
        pinchStart = {
          dist: Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY),
          scale: zoomState.scale
        };
      } else if (e.touches.length === 1) {
        var now = Date.now();
        if (now - lastTouch < 320) {
          // double-tap — toggle zoom 1x <-> 2.4x
          zoomState.scale = zoomState.scale > 1.05 ? 1 : 2.4;
          if (zoomState.scale === 1) { zoomState.tx = 0; zoomState.ty = 0; }
          applyTransform();
        }
        lastTouch = now;
        if (zoomState.scale > 1) {
          dragStart = { x: e.touches[0].clientX - zoomState.tx, y: e.touches[0].clientY - zoomState.ty };
        }
      }
    }, { passive: true });

    stage.addEventListener('touchmove', function(e){
      if (e.touches.length === 2 && pinchStart) {
        e.preventDefault();
        var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
        zoomState.scale = Math.max(1, Math.min(4, pinchStart.scale * (d / pinchStart.dist)));
        if (zoomState.scale === 1) { zoomState.tx = 0; zoomState.ty = 0; }
        applyTransform();
      } else if (e.touches.length === 1 && zoomState.scale > 1 && dragStart) {
        e.preventDefault();
        zoomState.tx = e.touches[0].clientX - dragStart.x;
        zoomState.ty = e.touches[0].clientY - dragStart.y;
        applyTransform();
      }
    }, { passive: false });

    stage.addEventListener('touchend', function(e){
      if (e.touches.length < 2) pinchStart = null;
      if (e.touches.length === 0) dragStart = null;
    });

    // Desktop click-to-zoom toggle (1x <-> 2.2x), wheel for fine-zoom
    stage.addEventListener('click', function(){
      if (window.matchMedia('(pointer: coarse)').matches) return; // mobile uses double-tap
      zoomState.scale = zoomState.scale > 1.05 ? 1 : 2.2;
      if (zoomState.scale === 1) { zoomState.tx = 0; zoomState.ty = 0; }
      applyTransform();
    });
    stage.addEventListener('wheel', function(e){
      if (window.matchMedia('(pointer: coarse)').matches) return;
      e.preventDefault();
      zoomState.scale = Math.max(1, Math.min(4, zoomState.scale + (e.deltaY < 0 ? 0.15 : -0.15)));
      if (zoomState.scale === 1) { zoomState.tx = 0; zoomState.ty = 0; }
      applyTransform();
    }, { passive: false });
  })();

  // === Reviews — inject verified-buyer tag into each card ===
  (function(){
    document.querySelectorAll('.cn1-rev-card').forEach(function(card){
      if (card.querySelector('.cn1-rev-loox-tag')) return;
      var tag = document.createElement('div');
      tag.className = 'cn1-rev-loox-tag';
      tag.innerHTML = '<svg aria-hidden="true"><use href="#i-shield"/></svg> Verified purchase';
      card.appendChild(tag);
    });
  })();

  // === Bundle radio swap — per-section (IDs suffixed with section.id) ===
  (function(){
    function fmt(n) { return '₹' + Number(n).toLocaleString('en-IN'); }
    document.querySelectorAll('[id^="gnBundleForm-"]').forEach(function(form){
      var sectionSuffix = form.id.replace('gnBundleForm-', '');
      var pay      = document.getElementById('bundlePay-' + sectionSuffix);
      var save     = document.getElementById('bundleSave-' + sectionSuffix);
      var ctaPrice = document.getElementById('bundleCtaPrice-' + sectionSuffix);
      function syncFrom(r) {
        var p = parseInt(r.dataset.price || '0', 10);
        var s = parseInt(r.dataset.save || '0', 10);
        if (pay) pay.textContent = fmt(p);
        if (save) save.textContent = fmt(s);
        if (ctaPrice) ctaPrice.textContent = fmt(p);
      }
      var initial = form.querySelector('input[type="radio"]:checked');
      if (initial) syncFrom(initial);
      form.querySelectorAll('input[type="radio"]').forEach(function(r){
        r.addEventListener('change', function(){ if (this.checked) syncFrom(this); });
      });
    });
  })();

  // === Hero pack picker → price row ===
  // Variant-mode safe: the row reflects the selected pack's TOTAL (data-display-price
  // + data-pack-mrp), NOT unit × data-qty — data-qty is always 1 in variant mode, which
  // is what made the row show the per-unit price (e.g. ₹1,749 for a 2-pack). Also syncs
  // once on load for the default-checked pack (fixes the price-row/chip/CTA desync when a
  // bundle is the default). CTA label + buy-qty stay owned by principal-hero.liquid inline JS.
  (function(){
    var radios = document.querySelectorAll('input[name="heroPack"]');
    if (!radios.length) return;
    var heroPriceNow   = document.getElementById('heroPriceNow');
    var heroPriceWas   = document.getElementById('heroPriceWas');
    var heroPriceBadge = document.getElementById('heroPriceBadge');
    function fmt(n) { return '₹' + Number(n).toLocaleString('en-IN'); }
    function parseInr(s) { var d = String(s == null ? '' : s).replace(/[^\d]/g, ''); return d ? parseInt(d, 10) : 0; }
    function applyRow(r) {
      if (!r) return;
      var packUnits = parseInt(r.dataset.packUnits || '1', 10);
      var totalNow  = parseInr(r.dataset.displayPrice) || (parseInt(r.dataset.unitPrice || '0', 10) * packUnits);
      var totalMrp  = parseInt(r.dataset.packMrp || '0', 10) || (parseInt(r.dataset.unitMrp || '0', 10) * packUnits);
      if (heroPriceNow && totalNow) heroPriceNow.textContent = fmt(totalNow);
      if (heroPriceWas && totalMrp) heroPriceWas.textContent = fmt(totalMrp);
      if (heroPriceBadge) heroPriceBadge.textContent = (totalMrp > totalNow) ? (Math.round((1 - totalNow/totalMrp) * 100) + '% off') : '';
    }
    radios.forEach(function(r){
      r.addEventListener('change', function(){ if (this.checked) applyRow(this); });
    });
    applyRow(document.querySelector('input[name="heroPack"]:checked'));  // sync on load (default pack)
  })();
})();

/* === Section break === */

(function(){
  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    gsap.registerPlugin(ScrollTrigger);

    // Hero image parallax (only on first slide; Flickity handles subsequent)
    var heroImg = document.getElementById('galleryMainImg');
    if (heroImg) {
      gsap.to(heroImg, {
        yPercent: -8,
        ease: 'none',
        scrollTrigger: {
          trigger: '.cn1-gallery-flick',
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.6
        }
      });
    }

    // R4.4: faster Calculator reveal — stagger 110ms→55ms, banner delay 220ms→100ms.
    // Total perceived load: ~0.6s (was ~1.4s).
    var calcRows = document.querySelectorAll('.cn1-calc-row');
    var calcBanner = document.querySelector('.cn1-calc-banner');
    var calcPct = document.querySelector('.cn1-calc-banner-pct');
    if (calcRows.length) {
      ScrollTrigger.create({
        trigger: '.cn1-calc',
        start: 'top 92%',
        once: true,
        onEnter: function(){
          calcRows.forEach(function(row, i){
            setTimeout(function(){
              row.classList.add('is-revealed');
              var price = row.querySelector('.cn1-calc-row-price');
              if (price) {
                price.classList.add('flash-red');
                setTimeout(function(){ price.classList.remove('flash-red'); }, 320);
              }
            }, i * 55);
          });
          if (calcBanner) {
            setTimeout(function(){ calcBanner.classList.add('is-popped'); }, calcRows.length * 55 + 100);
          }
          if (calcPct) {
            setTimeout(function(){ calcPct.classList.add('is-pulse'); }, calcRows.length * 55 + 500);
          }
        }
      });
    }

    // Reviews summary card lift on enter
    var revSummary = document.querySelector('.cn1-rev-summary');
    if (revSummary) {
      gsap.from(revSummary, {
        y: 32, opacity: 0,
        duration: 0.7, ease: 'power3.out',
        scrollTrigger: { trigger: revSummary, start: 'top 85%', toggleActions: 'play none none none' }
      });
    }

    // (Comparison row stagger handled by IntersectionObserver in body script — avoids "opacity: 0" stuck state when user jumps past trigger)
  }
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();

/* ---- Hero app-widget sync (Vibe Bundles) ----------------------------------
 * Mirrors the widget's tier selection onto the hero CTA + sync line. No-op on
 * pages without .cn1-hero-appcard. Display-sync ONLY: billing qty is enforced
 * server-side by the app's /cart/add interceptor + Shopify discount Function;
 * data-buy-qty is set as defense-in-depth. Adds NO [data-buy] click handlers
 * (contract §16 — body-level delegation stays the single handler). */
(function () {
  if (!document.querySelector('.cn1-hero-appcard')) return;
  var btn = document.getElementById('heroCtaPrimary');
  var totalEl = document.getElementById('heroCtaAppTotal');
  function inr(rupees) {
    /* aov:select detail.total is in RUPEES — the widget's own money() formats the
       raw number (verified in bundle-widget.js). Do NOT divide by 100: that shipped
       "₹18" for a ₹1,799 tier on 2026-07-03. (data-base-cents is paise, but the
       tier totals in the event are rupees — the app mixes conventions.) */
    return '₹' + Math.round(rupees).toLocaleString('en-IN');
  }
  document.addEventListener('aov:select', function (e) {
    var d = e && e.detail;
    if (!d || !d.units) return;
    if (btn) btn.dataset.buyQty = String(d.units);
    if (totalEl) totalEl.textContent = d.total ? '— ' + inr(d.total) : '';
    /* Sticky-bar mirror: on app-widget pages the sticky is a read-only mirror of
       the widget's tier (its own select/mrp/save are hidden per-template via the
       stickybar section's custom_css). Queried lazily — the sticky section renders
       after the hero in the DOM. Display-sync + defense-in-depth qty only, same as
       the hero CTA above; billing is enforced by the app's /cart/add interceptor +
       discount Function. Adds NO [data-buy] click handlers (contract §16). */
    var stkBtns = document.querySelectorAll('.js-stk-buy');
    for (var i = 0; i < stkBtns.length; i++) {
      stkBtns[i].dataset.buyQty = String(d.units);
      var sp = stkBtns[i].querySelector('.js-stk-price');
      if (sp && d.total) sp.textContent = inr(d.total);
    }
    /* Lower-CTA mirror (2026-09-15, audit A-01..A-05). Section buttons below the hero
       (solution / comparison / calculator / ugc) print a typed cta_label such as
       "⚡ Buy HubNest — ₹2,499", while the app bills the hero's selected tier. Mirror
       them like the sticky above: same qty, and the ₹ amount in the label becomes the
       selected tier total. Labels with no ₹ amount keep their words. The hero CTA
       (data-bundle-source) and the sticky (.js-stk-buy) are excluded. Display-sync +
       defense-in-depth qty only. Adds NO [data-buy] click handlers (contract §16). */
    var lowCtas = document.querySelectorAll('.principal-cta-primary[data-buy="checkout"]:not([data-bundle-source]):not(.js-stk-buy)');
    for (var j = 0; j < lowCtas.length; j++) {
      var c = lowCtas[j];
      c.dataset.buyQty = String(d.units);
      if (!d.total || c.classList.contains('is-unavailable')) continue;
      /* Rewrite text nodes only, from their first-seen text, so child markup survives
         and repeated tier changes never compound. Only the LAST ₹ amount in the label
         is the buy price; any earlier amount (e.g. "Save ₹500 · Buy ₹2,499") is kept. */
      var walker = document.createTreeWalker(c, NodeFilter.SHOW_TEXT, null);
      var node, lastNode = null;
      while ((node = walker.nextNode())) {
        if (node.__ctaBase === undefined) node.__ctaBase = node.nodeValue;
        if (/₹\s?[\d,]+/.test(node.__ctaBase)) lastNode = node;
      }
      if (lastNode) {
        var base = lastNode.__ctaBase;
        var hits = base.match(/₹\s?[\d,]+(?:\.\d+)?/g);
        var at = base.lastIndexOf(hits[hits.length - 1]);
        lastNode.nodeValue = base.slice(0, at) + inr(d.total) + base.slice(at + hits[hits.length - 1].length);
      }
    }
  });
})();

/* ============================================================
   Feature-pill snapshots (task 18, locked 2026-07-21).
   Drives .cn1-fp-dock rendered by principal-hero.liquid when
   pills_layout == "snap": tap a pill -> glass panel opens under
   the row with that pill's snapshot; 6s auto-close whose clock
   RESTARTS on any interaction inside the panel (a restart, never
   a kill — the panel can never wedge open); Escape + X close.
   No contact with [data-buy] — contract §16 stays intact.
   ============================================================ */
(function () {
  var AUTO_MS = 6000;

  function initDock(dock) {
    var track = dock.querySelector('[data-fp-track]');
    var panel = dock.querySelector('[data-fp-panel]');
    if (!track || !panel) return;
    var icHost = panel.querySelector('[data-fp-pic]');
    var title = panel.querySelector('[data-fp-pt]');
    var body = panel.querySelector('[data-fp-pp]');
    var bar = panel.querySelector('[data-fp-bar]');
    var openBtn = null, autoT = null;

    function stopClock() { if (autoT) { clearTimeout(autoT); autoT = null; } }
    function startClock() {
      stopClock();
      if (bar) {
        bar.style.transition = 'none';
        bar.style.transform = 'scaleX(1)';
        void bar.offsetWidth;
        bar.style.transition = 'transform ' + AUTO_MS + 'ms linear';
        bar.style.transform = 'scaleX(0)';
      }
      autoT = setTimeout(close, AUTO_MS);
    }
    function close() {
      stopClock();
      panel.hidden = true;
      if (openBtn) { openBtn.classList.remove('is-open'); openBtn.setAttribute('aria-expanded', 'false'); }
      openBtn = null;
    }
    function open(btn) {
      if (openBtn === btn) { close(); return; }
      close();
      openBtn = btn;
      btn.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var srcIc = btn.querySelector('[data-fp-icsrc]');
      if (icHost && srcIc) icHost.innerHTML = srcIc.innerHTML;
      var t = btn.querySelector('[data-fp-title]');
      var b = btn.querySelector('[data-fp-body]');
      if (title) title.textContent = t ? t.textContent : '';
      if (body) body.textContent = b ? b.textContent : '';
      panel.hidden = false;
      startClock();
      if (window.clarity) { try { window.clarity('event', 'pill_snap_open'); } catch (e) {} }
    }

    track.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fp]');
      if (btn) open(btn);
    });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-fp-x]')) { close(); return; }
      if (e.target.closest('[data-fp-more]')) {
        close();
        var sec = document.querySelector('[id^="shopify-section-"][id$="_solution"]') ||
                  document.querySelector('[id^="shopify-section-"][id$="_features"]');
        if (sec) sec.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    });
    /* interaction inside the panel restarts the clock */
    panel.addEventListener('pointerdown', function () { if (openBtn) startClock(); });
    panel.addEventListener('mouseenter', function () { if (openBtn) startClock(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openBtn) close();
    });
  }

  function boot() {
    var docks = document.querySelectorAll('[data-fp-dock]');
    for (var i = 0; i < docks.length; i++) initDock(docks[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
